import { useContext, useEffect, useState } from "react";
import BrandFullName from "../../brand_fullname/brand_fullname.component";
import Brand from "../../brand/brand.component";
import AH1SUModal from "../ah1su-modal/ah1su-modal.component";
import AHO2Content from "../aho2-content/aho2-content.component";
import AHO2NewUser from "../aho2-newuser-button/aho2-newuser-button.component";
import AHO1SignIn from "../aho1-signin/aho1-signin.component";
import AHO1Home from "../aho1-home/aho1-home.component";
import "./ah1.styles.scss";
import { UserContext } from "../../../contexts/users.context";
import { useNavigate } from "react-router-dom";
import { AffiliateContext } from "../../../contexts/affiliate.context";
const AHOne = () => {
  const [signUpModalClass, setSignUpModalClass] = useState(
    "aho2-newuser-form-modal"
  );
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const { affiliate, accountType } = useContext(AffiliateContext);
  useEffect(() => {
    if (user) {
      navigate("/home");
    }
  }, [user]);
  useEffect(() => {
    if (affiliate) {
      if (accountType == "Host") {
        navigate("/affiliate/host");
      } else if (accountType === "Kitchen") {
        navigate("/affiliate/kitchen");
      }
    }
  }, [affiliate]);
  const handleModal = () => {
    if (signUpModalClass === "aho2-newuser-form-show") {
      setSignUpModalClass("aho2-newuser-form-modal");
    } else if (signUpModalClass === "aho2-newuser-form-modal") {
      setSignUpModalClass("aho2-newuser-form-show");
    }
  };

  return (
    <div className="ah-one-container">
      <div className="brand-one">
        <BrandFullName />
      </div>
      <div className="brand-two">
        <Brand />
      </div>

      {window.innerWidth < 1024 ? (
        <div className="ah-one-content-two">
          <AHO2NewUser handleModal={handleModal} />
          <div className={signUpModalClass}>
            <AH1SUModal closeFunction={handleModal} />
          </div>
          <AHO2Content />
        </div>
      ) : (
        <div className="ah-one-content-one">
          <AHO1SignIn />
          <AHO1Home />
        </div>
      )}
    </div>
  );
};
export default AHOne;
